import { mapActions } from 'vuex';
import { ToastProgrammatic as Toast } from 'buefy';

import Terms from '@/components/Setting/Terms/Terms.vue';
import PlanSelector from '@/components/Setting/PlanSelector/PlanSelector.vue';
import Checkout from '@/components/Setting/Checkout/Checkout.vue';
import Upgraded from '@/components/Setting/Upgraded/Upgraded.vue';
import { CONTACT, UPGRADE } from '@/store/setting/constants';
import { SNACKBAR_TYPES } from '@/utils/constants';

export default {
  name: 'Plans',
  components: {
    Terms,
    PlanSelector,
    Checkout,
    Upgraded,
  },
  data() {
    return {
      termsAgreed: false,
      loading: false,
    };
  },
  computed: {
    currentStep: {
      get() {
        const step = this.$route.query?.step;
        if (!step) {
          return 0;
        }
        return Number(this.$route.query.step);
      },
      set(value) {
        this.$router.push({
          query: {
            step: value,
          },
        });
      },
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    onNextStep() {
      if (this.currentStep < 3) {
        this.currentStep += 1;
      }
    },
    onUpgrade() {
      this.onNextStep();
    },
    async onContact(contactForm) {
      try {
        this.loading = true;
        await this.contact(contactForm);
        this.$snackbar({
          title: '聯絡資訊成功送出',
          msg: '銷售專員將與您聯繫',
          type: SNACKBAR_TYPES.SUCCESS,
        });
        this.$refs['plan-selector'].reset();
      } catch (ex) {
        const errorMessage = ex.message ? `(${ex.message})` : '';
        Toast.open({
          message: `傳送資料時發生錯誤，請重試一次。${errorMessage}`,
          type: 'is-danger',
        });
      } finally {
        this.loading = false;
      }
    },
    async onSubmit(form) {
      try {
        this.loading = true;
        await this.upgrade(form);
        this.onNextStep();
      } catch (ex) {
        const errorMessage = ex.message ? `(${ex.message})` : '';
        Toast.open({
          message: `目前無法升級您的方案，請重試一次。${errorMessage}`,
          type: 'is-danger',
        });
      } finally {
        this.loading = false;
      }
    },
    ...mapActions('setting', {
      contact: CONTACT,
      upgrade: UPGRADE,
    }),
  },
};
